import React from 'react';
import { Button } from "./button";
import { Checkbox } from "./checkbox";
import { Label } from "./label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "./Select";
import { Input } from "./input";
import { X, Minus, Plus } from 'lucide-react';

export default function IntegratedFrameSettings({ frameSettings, onSettingsChange, disabled = false }) {
  const handleFrameSettingsChange = (key, value) => {
    if (disabled) return;
    onSettingsChange({ ...frameSettings, [key]: value });
  };

  const line1Options = frameSettings.availableItems.filter(item =>
    ['coordinates_dms', 'coordinates_metric', 'place_name', 'custom_text'].includes(item.id)
  );

  const line2Options = frameSettings.availableItems.filter(item =>
    ['distance', 'hours', 'elevation'].includes(item.id)
  );

  const setLine1Item = (item) => {
    if (disabled) return;
    const newSettings = { ...frameSettings };
    newSettings.line1Items = item ? [item] : [];
    if (item?.id === 'custom_text' && !frameSettings.customText) {
      newSettings.customText = '';
    }
    onSettingsChange(newSettings);
  };

  const toggleLine2Item = (item) => {
    if (disabled) return;
    const newSettings = { ...frameSettings };
    const itemIndex = newSettings.line2Items.findIndex(i => i.id === item.id);

    if (itemIndex === -1) {
      newSettings.line2Items = [...newSettings.line2Items, item];
    } else {
      newSettings.line2Items = newSettings.line2Items.filter(i => i.id !== item.id);
    }

    onSettingsChange(newSettings);
  };

  const isLine2ItemSelected = (itemId) => {
    return frameSettings.line2Items.some(item => item.id === itemId);
  };

  const increment = () => {
    if (frameSettings.framePercentage < 10) {
      handleFrameSettingsChange('framePercentage', frameSettings.framePercentage + 1);
    }
  };

  const decrement = () => {
    if (frameSettings.framePercentage > 1) {
      handleFrameSettingsChange('framePercentage', frameSettings.framePercentage - 1);
    }
  };

  return (
    <div className="space-y-6">

      {/* Frame Settings - Always visible but conditionally disabled */}
      <div className={`space-y-6 ${disabled ? 'opacity-40 pointer-events-none' : ''}`}>
        <div className="space-y-4">
          <div className="flex sm:space-x-4 space-y-3 sm:space-y-0 items-center justify-center">
            {/* <div className="sm:w-1/4">
              <h3 className="font-medium text-gray-700">Settings</h3>
              <p className="text-sm text-gray-500 mt-1">Customize appearance</p>
            </div> */}

            <div className="flex space-y-4">
              <div className="grid grid-cols-2 gap-4">
                {/* <div className="space-y-2">
                  <Label htmlFor="textPosition" className="text-sm text-gray-600">Text Position</Label>
                  <Select
                    value={frameSettings.textPosition}
                    onValueChange={(value) => handleFrameSettingsChange('textPosition', value)}
                    // disabled={!frameSettings.addText || disabled}
                  >
                    <SelectTrigger className="bg-white border border-none rounded-xl w-[100px]">
                      <SelectValue placeholder="Select position" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="top">Top</SelectItem>
                      <SelectItem value="bottom">Bottom</SelectItem>
                    </SelectContent>
                  </Select>
                </div> */}

                <div className="space-y-2 text-center">
                  <Label htmlFor="frameSize" className="text-sm text-gray-600">Frame Size</Label>
                  <div className="flex items-center gap-2 w-1/2">
                    <button
                      onClick={decrement}
                      className="p-2 rounded-xl bg-white hover:bg-gray-100"
                    >
                      <Minus className="w-4 h-4" />
                    </button>
                    <span className="text-lg">{frameSettings.framePercentage}</span>
                    <button
                      onClick={increment}
                      className="p-2 rounded-xl bg-white hover:bg-gray-100"
                    >
                      <Plus className="w-4 h-4" />
                    </button>
                  </div>
                </div>

                <div className="space-y-2">
                  <Label htmlFor="frameColor" className="text-sm text-gray-600">Frame Color</Label>
                  <div className="flex gap-2">
                    <Input
                      type="color"
                      id="frameColor"
                      value={frameSettings.frameColor}
                      onChange={(e) => handleFrameSettingsChange('frameColor', e.target.value)}
                      // disabled={!frameSettings.addText || disabled}
                      className="w-12 p-1 bg-white hover:bg-gray-300"
                    />
                  </div>
                </div>
                {/* 
                <div className="space-y-2">
                  <Label htmlFor="textColor" className="text-sm text-gray-600">Text Color</Label>
                  <div className="flex gap-2">
                    <Input
                      type="color"
                      id="textColor"
                      value={frameSettings.textColor}
                      onChange={(e) => handleFrameSettingsChange('textColor', e.target.value)}
                      // disabled={!frameSettings.addText || disabled}
                      className="w-12 p-1 bg-white hover:bg-gray-300"
                    />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        {/* <div className="flex items-center space-x-2">
          <Checkbox
            id="addText"
            checked={frameSettings.addText}
            onCheckedChange={(checked) => handleFrameSettingsChange('addText', checked)}
            className="h-6 w-6 border-black rounded-xl"
            disabled={true}
          />
          <Label htmlFor="addText" className="font-medium">Add Text</Label>
        </div>
        <div className="space-y-4">
          <div className="sm:flex sm:space-x-4 space-y-3 sm:space-y-0">
            <div className="sm:w-1/4">
              <h3 className="font-medium text-gray-700">First Line</h3>
              <p className="text-sm text-gray-500 mt-1">Choose one option</p>
            </div>

            <div className="flex-1 space-y-3">
              <div className="p-4 bg-white rounded-xl shadow-xl border border-gray-100">
                <div className="flex flex-wrap gap-2">
                  {frameSettings.line1Items.map((item) => (
                    <div key={item.id} className="bg-gray-200 px-3 py-1.5 rounded-xl flex items-center gap-2">
                      {item.id === 'custom_text' ? (
                        <Input
                          type="text"
                          value={frameSettings.customText || ''}
                          onChange={(e) => handleFrameSettingsChange('customText', e.target.value)}
                          placeholder="Type custom text"
                          className="h-7 text-sm min-w-[200px] border-0 bg-transparent focus-visible:ring-0"
                          disabled={!frameSettings.addText || disabled}
                        />
                      ) : (
                        <span className="text-gray-700">{item.content}</span>
                      )}
                      <button
                        onClick={() => setLine1Item(null)}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                        disabled={!frameSettings.addText || disabled}
                      >
                        <X size={14} />
                      </button>
                    </div>
                  ))}
                  {frameSettings.line1Items.length === 0 && (
                    <span className="text-gray-400 text-sm">Select one option below</span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap gap-2">
            {line1Options.map((item) => (
              <Button
                key={item.id}
                variant="default"
                size="sm"
                onClick={() => setLine1Item(item)}
                disabled={!frameSettings.addText || disabled}
                className={`shadow-xl ${frameSettings.line1Items[0]?.id === item.id ? 'text-black' : 'text-black bg-gray-200 border-gray-400 hover:bg-gray-400'}`}
              >
                {item.content}
              </Button>
            ))}
          </div>
        </div>

        <div className="space-y-4">
          <div className="sm:flex sm:space-x-4 space-y-3 sm:space-y-0">
            <div className="sm:w-1/4">
              <h3 className="font-medium text-gray-700">Second Line</h3>
              <p className="text-sm text-gray-500 mt-1">Combine multiple options</p>
            </div>

            <div className="flex-1 space-y-3">
              <div className="p-4 bg-white rounded-xl shadow-xl border border-gray-100">
                <div className="flex flex-wrap gap-2">
                  {frameSettings.line2Items.map((item) => (
                    <div key={item.id} className="bg-gray-200 px-3 py-1.5 rounded-xl flex items-center gap-2">
                      <span className="text-gray-700">{item.content}</span>
                      <button
                        onClick={() => toggleLine2Item(item)}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                        disabled={!frameSettings.addText || disabled}
                      >
                        <X size={14} />
                      </button>
                    </div>
                  ))}
                  {frameSettings.line2Items.length === 0 && (
                    <span className="text-gray-400 text-sm">Select options below</span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap gap-2 justify-center">
            {line2Options.map((item) => (
              <Button
                key={item.id}
                variant="default"
                size="sm"
                onClick={() => toggleLine2Item(item)}
                disabled={!frameSettings.addText || disabled}
                className={`shadow-xl ${isLine2ItemSelected(item.id) ? 'text-black' : 'text-black bg-gray-200 border-gray-400 hover:bg-gray-400'}`}
              >
                {item.content}
              </Button>
            ))}
          </div>
        </div> */}
      </div>
    </div>
  );
}